'use client';
import { PrinceGeorge } from '../components/regions/prince-george/prince-george';

export default PrinceGeorge;
